import React from 'react';
import { ArrowRight, PlayCircle } from 'lucide-react';
import { Button } from './ui/button';
import { heroData } from '../data/mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-red-50 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-red-100 rounded-full blur-3xl animate-pulse delay-1000"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-32 text-center">
        <div className="space-y-8 animate-fadeIn">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-50 border border-red-200 rounded-full text-red-600 text-sm font-medium">
            <span className="w-2 h-2 bg-red-600 rounded-full animate-pulse"></span>
            Digital Marketing Agency
          </div>

          {/* Headline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-slate-900 leading-tight">
            {heroData.headline}
          </h1>

          {/* Subheadline */}
          <p className="text-xl sm:text-2xl text-slate-600 max-w-4xl mx-auto leading-relaxed">
            {heroData.subheadline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Button
              size="lg"
              onClick={() => scrollToSection('contact')}
              className="bg-red-600 text-white hover:bg-red-700 hover:scale-105 transition-all duration-300 shadow-2xl shadow-red-500/20 px-8 py-6 text-lg font-semibold group"
            >
              {heroData.cta1}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('clients')}
              className="bg-transparent border-2 border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white hover:scale-105 transition-all duration-300 px-8 py-6 text-lg font-semibold group"
            >
              {heroData.cta2}
              <PlayCircle className="ml-2 w-5 h-5 group-hover:scale-110 transition-transform" />
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-8 pt-16 text-slate-700">
            <div className="text-center">
              <div className="text-4xl font-bold text-red-600">100+</div>
              <div className="text-sm text-slate-600 mt-1">Projects Completed</div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-slate-300"></div>
            <div className="text-center">
              <div className="text-4xl font-bold text-red-600">50+</div>
              <div className="text-sm text-slate-600 mt-1">Happy Clients</div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-slate-300"></div>
            <div className="text-center">
              <div className="text-4xl font-bold text-red-600">3M+</div>
              <div className="text-sm text-slate-600 mt-1">Social Reach</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-slate-400 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-red-600 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
